import { EnvValueSetting } from '@/modules/auth/models/interfaces/EnvValueSetting';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class AuthEnvironmentValueSetting extends BaseModel {
  settings: EnvValueSetting;

  constructor(model: Partial<AuthEnvironmentValueSetting>) {
    super();
    this.settings = model.settings || ({} as EnvValueSetting);
  }
}
